export default __webpack_public_path__ + "static/media/bender.036eaadc.png";